<i18n lang="yaml">
zh:
  dialog_title_edit: "故事设置"
  dialog_title_new: "新建故事"
  writing_perspective: "写作视角"
  article_type: "故事类型"
  type: "类型"
  article_style: "故事文风"
  style: "文风"
  article_age: "故事时代"
  age: "时代"
  story_bg: "故事背景"
  story_bg_placeholder: "请描述你想创作的故事…可以是简单的一句话或者是一大段设定"
  story_cp: "故事人设"
  story_cp_placeholder: "请输入故事人物设定"
  start_chapter: "从第几章开始创作?"
  input_number: "请输入数字序号"
  chapter_prefix: "第"
  chapter_suffix: "章"
  input_outline: "请输入第{n}章大纲"
  input_pre_content: "请输入你已创作的第{n}章正文内容"
  cancel: "取 消"
  save: "保 存"
  next: "下一步"
  back: "返回上一步"
  confirm: "确 定"
  select_writing_perspective: "请选择写作视角"
  select_article_type: "请选择故事类型"
  select_article_style: "请选择故事文风"
  input_article_age: "请输入故事时代"
  input_story_bg: "请输入故事背景"
  input_story_cp: "请输入故事人设"
  input_start_outline: "请输入故事起始大纲"
  input_start_outline_number: "请输入故事起始大纲序号"
  input_pre_content_error: "请输入上一章故事正文"
  select_file: "请选择文件"
  update_success: "修改成功"
  create_success: "创建成功"
en:
  dialog_title_edit: "Edit Story"
  dialog_title_new: "New Story"
  writing_perspective: "Writing Perspective"
  article_type: "Story Type"
  type: "Type"
  article_style: "Story Style"
  style: "Style"
  article_age: "Story Era"
  age: "Era"
  story_bg: "Story Background"
  story_bg_placeholder: "Describe the story you want to create... It can be a simple sentence or a long setting."
  story_cp: "Character Setting"
  story_cp_placeholder: "Please enter character settings"
  start_chapter: "Start from which chapter?"
  input_number: "Please enter a number"
  chapter_prefix: "Chapter"
  chapter_suffix: ""
  input_outline: "Please enter the outline for chapter {n}"
  input_pre_content: "Please enter the content of chapter {n} you have already written"
  cancel: "Cancel"
  save: "Save"
  next: "Next"
  back: "Back"
  confirm: "Confirm"
  select_writing_perspective: "Please select writing perspective"
  select_article_type: "Please select story type"
  select_article_style: "Please select story style"
  input_article_age: "Please enter story era"
  input_story_bg: "Please enter story background"
  input_story_cp: "Please enter character setting"
  input_start_outline: "Please enter starting outline"
  input_start_outline_number: "Please enter starting outline number"
  input_pre_content_error: "Please enter previous chapter content"
  select_file: "Please select file"
  update_success: "Update successful"
  create_success: "Created successfully"
</i18n>
<template>

    <!-- 长篇 弹窗 -->
    <el-dialog
      class="custom-dialog new-changpian-dialog"
      ref="dialog"
      :visible.sync="showChangpianDialogFlag"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :withHeader="false"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-click-modal="false"
      :wrapperClosable="false"
      :width="drawerWidth"
      :top="dialogTop"
      @close="close"
      >
      <el-form label-position="top">
        <el-row type="flex" align="middle">
          <el-button v-if="!story.id" icon="el-icon-arrow-left" circle @click="$router.back()" style="margin-right: 15px"></el-button>
          <h3>{{ $t(story.id ? 'dialog_title_edit' : 'dialog_title_new') }}</h3>
        </el-row>
        <div v-if="step1Visable">
          <el-row type="flex" justify="space-between">
            <el-col :span="dialogStyle.colSpan">
              <el-form-item :label="$t('writing_perspective')" required>
                  <el-radio-group v-model="formData.writingPerspective">
                    <el-radio :border="false" :label="item.name" :key="index" v-for="(item,index) in enums.WritingPerspectiveEnum">{{item.desc}}</el-radio>
                  </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="dialogStyle.colSpan" :offset="dialogStyle.colOffset" v-if="enums.ArticleTypeEnum && enums.ArticleTypeEnum.length>0">
              <el-form-item :label="$t('article_type')" required>
                <el-cascader class="custom-select-v1" v-if="storyTiaojian.length>0"
                    v-model="articleTypeIdOptions"
                    :placeholder="$t('type')"
                    :options="storyTiaojian.filter(item1=>item1.code==1)[0].children.filter(item2=>item2.code==9)[0].children"
                    @change="$handleChangeArticleTypeId($event, formData)"
                    :props="{
                      expandTrigger: 'hover'
                    }"
                    :show-all-levels="false"
                    filterable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mgt-10" type="flex" justify="space-between">
            <el-col :span="dialogStyle.colSpan" v-if="enums.ArticleStyleEnum">
              <el-form-item :label="$t('article_style')" required>
                <el-cascader class="custom-select-v1"
                    v-model="articleStyleIdOptions"
                    :placeholder="$t('style')"
                    :options="storyTiaojian.filter(item1=>item1.code==5)[0].children"
                    :props="{ expandTrigger: 'hover' }"
                    @change="$handleChangeArticleStyleId($event, formData)"
                    :show-all-levels="false"
                    filterable></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="dialogStyle.colSpan" :offset="dialogStyle.colOffset">
              <el-form-item :label="$t('article_age')" required>
                <el-cascader class="custom-select-v1"
                    v-model="articleAgeIdOptions"
                    :placeholder="$t('age')"
                    :options="storyTiaojian.filter(item1=>item1.code==4)[0].children"
                    :props="{ expandTrigger: 'hover' }"
                    @change="$handleChangeArticleAgeId($event, formData)"
                    :show-all-levels="false"
                    filterable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mgt-10">
            <el-form-item :label="$t('story_bg')" required>
              <el-input type="textarea" :placeholder="$t('story_bg_placeholder')"
                v-model="formData.storyBg" :rows="3" maxlength="1000" show-word-limit clearable class="story-idea">
              </el-input>
            </el-form-item>
          </el-row>
          <el-row class="mgt-10">
            <el-form-item :label="$t('story_cp')" required>
              <el-input type="textarea" :placeholder="$t('story_cp_placeholder')"
                v-model="formData.storyCp" :rows="3" maxlength="2000" show-word-limit clearable class="story-idea">
              </el-input>
            </el-form-item>
          </el-row>
        </div>
        <div v-if="step2Visable" class="mgt-10" style="background: #F2F3FF;border-radius: 16px;padding: 0 1rem 1rem 1rem;">
          <el-row>
            <el-form-item :label="$t('start_chapter')" required>
              <el-input type="number" min="1" :placeholder="$t('input_number')" @change="startOutlineNumberChange"
                v-model="formData.startOutlineNumber" style="width: 200px;">
                <template slot="prepend">{{$t('chapter_prefix')}}</template>
                <template slot="append">{{$t('chapter_suffix')}}</template>
              </el-input>
            </el-form-item>
          </el-row>
          <el-row class="mgt-10">
            <el-form-item :label="$t('input_outline', { n: formData.startOutlineNumber || '' })" required>
              <el-input type="textarea" v-model="formData.startOutline" :rows="3" maxlength="1000" show-word-limit clearable class="story-idea no-border-input"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="mgt-10" v-if="formData.startOutlineNumber && formData.startOutlineNumber>1">
            <el-form-item :label="$t('input_pre_content', { n: formData.startOutlineNumber?formData.startOutlineNumber-1:'' })" required>
              <el-input v-if="$i18n.locale === 'zh'" type="textarea"
                v-model="formData.preContent" :rows="3" maxlength="4000" show-word-limit clearable class="story-idea no-border-input">
              </el-input>
              <el-input v-else type="textarea"
                v-model="formData.preContent" :rows="3" show-word-limit clearable class="story-idea no-border-input">
              </el-input>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <div v-if="story.id" type="flex" justify="center" style="display: flex;justify-content: center;">
            <el-button style="padding: 10px 55px" @click="close()">{{$t('cancel')}}</el-button>
            <el-button style="padding: 10px 55px;margin-left: 30px" type="primary" @click="newStoryByIdea">{{$t('save')}}</el-button>
          </div>
          <div v-else>
            <div v-if="dialogStyle.currentStep == 1" style="display: flex;justify-content: center;">
              <el-button :disabled="!btnActiveFlag" style="padding: 10px 55px;margin-left: 30px" type="primary" @click="goStep2">{{$t('next')}}</el-button>
            </div>
            <div v-else style="display: flex;justify-content: center;">
              <el-button style="padding: 10px 55px" @click="goStep1">{{$t('back')}}</el-button>
              <el-button style="padding: 10px 55px;margin-left: 30px" type="primary" @click="newStoryByIdea">{{$t('confirm')}}</el-button>
            </div>
          </div>
        </div>
    </el-dialog>
</template>
<script>
import * as StoryCpApi from '@/api/storycp'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import * as ArticleApi from '@/api/article'
export default {
  name: 'StoryByIdea',
  props: {
    enums: {
      type: Object,
      default: {ArticleTypeEnum: []}
    },
    channel: {
      type: String,
      default: 'workspace_index'
    },
  },
  components: {

  },
  data() {
    return {
      sliderBoxActive: 0,
      synesthesiaElements:[],
      cps:[],
      hots:[],
      articleTypeIdOptions: [],
      articleStyleIdOptions: [],
      articleAgeIdOptions: [],
      formData: {
        writingPerspective: 'THIRD_PERSON',
        articleType: 'CP_YANQING',
        articleStyle: 'ZHENGWEN',
        articleAge: 'XIANDAI',
        articleTypeId: '',
        articleStyleId: '',
        articleAgeId: '',
        storyBg: '',
        storyCp: '',
        startOutlineNumber: 1,
        startOutline: '',
        preContent: '',
      },
      rules: {
        picUrl: [
          { required: true, message: this.$t('select_file'), trigger: 'blur' }
        ]
      },
      step1Visable: true,
      step2Visable: false,
      dialogStyle: {
        colSpan: 10,
        colOffet: 2,
        totalStep: 2,
        currentStep: 1
      }
    }
  },
  mounted() {
    console.log('changpian dialog mounted');
    console.log(this.story);

    this.handleIdeaRef('element')
    this.handleIdeaRef('hot')
    this.handleIdeaRef('cp')

    window.addEventListener('resize', this.forceUpdate);

    if(this.story.id){
      this.formData.writingPerspective = this.story.writingPerspective
      this.formData.articleType = this.story.articleType
      this.formData.articleStyle = this.story.articleStyle
      this.formData.articleAge = this.story.articleAge
      this.formData.storyBg = this.story.storyBg
      this.formData.storyCp = this.story.storyCp
      this.formData.startOutlineNumber = this.story.startOutlineNumber
      this.formData.startOutline = this.story.startOutline
      this.formData.preContent = this.story.preContent
      // 动态知识条件
      this.formData.articleTypeId = this.story.articleTypeId
      this.formData.articleStyleId = this.story.articleStyleId
      this.formData.articleAgeId = this.story.articleAgeId

      this.articleTypeIdOptions = this.story.articleTypeIdFull?JSON.parse(this.story.articleTypeIdFull):[]
      this.articleStyleIdOptions = [this.story.articleStyleId]
      this.articleAgeIdOptions = [this.story.articleAgeId]
    }

    this.$nextTick(() => {
      if ('workspace_index' == this.channel) {// 初始化表单
        this.sliderBoxActive = 0
        console.log('StoryIdeaDialog init')
        this.setStory({id: '', writingPerspective: 'FIRST_PERSON', storyCp: '', storyHot: '', storyIdeaElement: ''})
      }
    })
  },
  computed: {
    ...mapState(['user', 'story', 'showChangpianDialogFlag', 'storyTiaojian']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '85%' : '40%';
    },
    dialogTop() {
      return window.innerWidth <= 768 ? "5%" : '10vh';
    },
    dialogTitle () {
      return this.story.id ? this.$t('dialog_title_edit') : this.$t('dialog_title_new')
    },
    showHeader() {
      return window.innerWidth <= 768
    },
    btnActiveFlag() {
      return (this.formData.storyCp && this.formData.storyCp.length>0)
      && (this.formData.storyBg && this.formData.storyBg.length>0)
      && (this.formData.articleTypeId && Number(this.formData.articleTypeId)>0)
      && (this.formData.articleStyleId && Number(this.formData.articleStyleId)>0)
      && (this.formData.articleAgeId && Number(this.formData.articleAgeId)>0)
    },
  },
  created() {
    console.log('created');
  },
  methods: {
    ...mapMutations(['setStory', 'setShowChangpianDialogFlag']),
    close(){
      this.setShowChangpianDialogFlag(false);
    },
    newStoryByIdea() {
      if (!this.formData.writingPerspective || !this.formData.writingPerspective.trim()) {
          this.$message.error(this.$t('select_writing_perspective'));
          return false;
      }
      if (!this.formData.articleTypeId || !this.formData.articleTypeId.trim() || Number(this.formData.articleTypeId)==0) {
          this.$message.error(this.$t('select_article_type'));
          return false;
      }
      if (!this.formData.articleStyleId || !this.formData.articleStyleId.trim() || Number(this.formData.articleStyleId)==0) {
          this.$message.error(this.$t('select_article_style'));
          return false;
      }
      if (!this.formData.articleAgeId || !this.formData.articleAgeId.trim() || Number(this.formData.articleAgeId)==0) {
          this.$message.error(this.$t('input_article_age'));
          return false;
      }
      if (!this.formData.storyBg || !this.formData.storyBg.trim()) {
          this.$message.error(this.$t('input_story_bg'));
          return false;
      }
      if (!this.formData.storyCp || !this.formData.storyCp.trim()) {
          this.$message.error(this.$t('input_story_cp'));
          return false;
      }
      if (!this.formData.startOutline || !this.formData.startOutline.trim()) {
        if(!this.story){
          this.$message.error(this.$t('input_start_outline'));
          return false;
        }
      }
      if (!this.formData.startOutlineNumber) {
        if(!this.story){
          this.$message.error(this.$t('input_start_outline_number'));
          return false;
        }
      }
      if (!this.formData.preContent || !this.formData.preContent.trim()) {
          if(!this.story){
            this.$message.error(this.$t('input_pre_content_error'));
            return false;
          }
      }

      this.story.writingPerspective = this.formData.writingPerspective
      this.story.articleType = this.formData.articleType
      this.story.articleStyle = this.formData.articleStyle
      this.story.articleAge = this.formData.articleAge
      this.story.storyBg = this.formData.storyBg
      this.story.storyCp = this.formData.storyCp
      this.story.startOutlineNumber = this.formData.startOutlineNumber
      this.story.startOutline = this.formData.startOutline
      this.story.preContent = this.formData.preContent
      // 动态知识库
      this.story.articleTypeId = this.formData.articleTypeId
      this.story.articleStyleId = this.formData.articleStyleId
      this.story.articleAgeId = this.formData.articleAgeId
      this.story.articleTagId = 0
      this.story.articleTypeIdFull = JSON.stringify(this.articleTypeIdOptions)

      if(this.story.id){
        ArticleApi.update(this.story).then(res => {
            if(res.data.code == 0){
              console.log('update cp story')
              this.setStory(this.story)
              this.close()
              this.$message.success(this.$t('update_success'));
            }else{
              this.$message.error(res.data.msg);
            }
        })
      }else{
        this.story.fromType = 'writer_client_cp'
        ArticleApi.create(this.story).then(res => {
            if(res.data.code == 0){
              let data = res.data.data
              console.log('create cp story')
              this.setStory(data)
              this.close()
              this.goStep1()
              this.$message.success(this.$t('create_success'));
              this.$parent.handlePageChapter(1)
            }else{
              this.$message.error(res.data.msg);
            }
        })
      }
    },
    handleIdeaRef(flag) {
      if(flag == 'element') {
        StorySynesthesiaElementApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.synesthesiaElements = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }else if(flag == 'hot') {
        StoryHotApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.hots = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }else if(flag == 'cp') {
        StoryCpApi.page({size: 100}).then(res => {
          let result = res.data.data;
          const shuffledArray = this.shuffleArray([...result.records])
          this.cps = shuffledArray.slice(0, 4);
          // this.synesthesiaElements = result.records
        });
      }
    },
    handleIdeaClick(flag, text) {
      console.log('flag, text', flag, text);
      if(flag == 'element') {
        if(!this.story.storyIdeaElement){
          this.story.storyIdeaElement = text
        }else if(this.story.storyIdeaElement.indexOf(text) == -1){
          this.story.storyIdeaElement = this.story.storyIdeaElement +  ',' + text
        }
      }else if(flag == 'hot') {
        if(!this.story.storyHot){
          console.log('flag, text', flag, text);
          this.story.storyHot = text
          console.log('storyHot', this.story.storyHot);
          this.setStory(this.story)
        }else if(this.story.storyHot.indexOf(text) == -1){
          console.log('flag, text', flag, text);
          this.story.storyHot = this.story.storyHot +  ',' + text
        }
      }else if(flag == 'cp') {
        if(!this.story.storyCp){
          this.story.storyCp = text
        }else if(this.story.storyCp.indexOf(text) == -1){
          this.story.storyCp = this.story.storyCp +  ',' + text
        }
      }
    },
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            // 生成从0到i的随机索引
            const j = Math.floor(Math.random() * (i + 1));
            // 交换元素
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    },
    forceUpdate() {
      this.$forceUpdate(); // 强制重新渲染，以更新计算属性
    },
    goStep1() {
      this.step1Visable = true
      this.step2Visable = false
      this.dialogStyle.currentStep = 1
    },
    goStep2() {
      this.step1Visable = false
      this.step2Visable = true
      this.dialogStyle.currentStep = 2
      console.log(this.formData)
    },
    startOutlineNumberChange() {
      this.formData.startOutlineNumber = parseInt(this.formData.startOutlineNumber)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.forceUpdate);
  },
}
</script>

<style scoped lang="scss">
$tagMT: .5rem;
/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .story-idea .el-textarea__inner{
  // background: #F4F4F4;
  padding: 1rem;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
  font-weight: normal;
}
.custom-select-v1 {
  /deep/ .el-input__inner {
    border-radius: 20px;
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    background: #FFFFFF;
    border: 1px solid #EBEEF5 !important;
  }
  /deep/ .el-input__suffix {
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  /deep/ .el-input--suffix {
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.story-idea-tag-box {
  margin-top: $tagMT;
  &-tag {
    display: inline-block;
    background: #F2F3FF;
    border-radius: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #242424;
    padding: .25rem 1rem;
    margin: 0 .5rem .5rem 0;
    white-space: nowrap;
  }
}
.get-more {
  font-size: 12px;
  color: #0052D9;
  white-space: nowrap;
  margin-top: $tagMT;
}
.field-title {
  color: rgba(0,0,0,0.5);
}
</style>
